import React, { useEffect } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import Legend from './Legend';
import LayerControl from './LayerControl';
import { shouldShowAutoPath, shouldShowCustomPath, shouldShowDistanceLabels, hasPathsToShow, getMapContainerClassName } from '../Services';
import { useTp } from '../context/TpContext';
import { useMapInitialization } from './hooks/useMapInitialization';
import { useMapInteractions } from './hooks/useMapInteractions';
import { useMapData } from './hooks/useMapData';
import './styles/index.js';

export default function MapComponent() {
  const {
    currentMode, locations, setLocations, startId, setPath, visiblePaths,
    mapPointSelectCallback, setMapRef, setMapReady,
    // from context
    addPointType, defaultQuantity
  } = useTp();

  const autoPath = visiblePaths.auto || [];
  const customPath = visiblePaths.custom || [];

  const showAutoPath = shouldShowAutoPath(currentMode);
  const showCustomPath = shouldShowCustomPath(currentMode);
  const showDistanceLabels = shouldShowDistanceLabels(currentMode);
  const { hasAutoPaths, hasCustomPaths } = hasPathsToShow(showAutoPath, showCustomPath, autoPath, customPath);

  const { mapContainer, map, mapError, mapReady, sourcesReadyRef, isMountedRef } = useMapInitialization();

  // now passes addPointType + defaultQuantity so clicks create points
  useMapInteractions({
    map, mapReady, sourcesReadyRef, isMountedRef,
    currentMode, locations, setLocations, mapPointSelectCallback,
    addPointType, defaultQuantity
  });

  useMapData({
    map, mapReady, sourcesReadyRef, isMountedRef,
    locations, startId, autoPath, customPath,
    showAutoPath, showCustomPath, showDistanceLabels, currentMode
  });

  useEffect(() => {
    if (map.current && mapReady) { setMapRef(map.current); setMapReady(true); }
  }, [map, mapReady, setMapRef, setMapReady]);

  if (mapError) return <div className="map-error"><h3>Error Loading Map</h3><p>{mapError}</p></div>;

  const className = getMapContainerClassName(currentMode);
  return (
    <div className={className}>
      <div ref={mapContainer} className="map-container" />
      <LayerControl map={map.current} mapReady={mapReady} currentMode={currentMode} />
      {(hasAutoPaths || hasCustomPaths) && <Legend />}
    </div>
  );
}
